<template>
  <header class="page-title-bar mb-2 px-0">
    <div class="row text-center text-sm-left">
      <div class="col">
        <h1 class="page-title text-left">{{ protocol.title }}</h1>
        <span v-if="protocol.is_secondary"
              class="badge badge-info">Protocolo secundario</span>
        
        <div class="d-flex mt-3 mb-3">
          <a class="btn-account" href="#">
            <div class="user-avatar mr-2">
              <img alt=""
                   :src="protocol.user.avatar">
            </div>
            <div class="account-summary">
              <h1 class="card-title">{{ protocol.user.full_name }}</h1>
              <h6 class="card-subtitle text-muted">Responsable de protocolo</h6>
            </div>
          </a>
        </div>
        
        <span class="font-weight-bold d-block text-left">Resumen del protocolo:</span>
        
        <p class="protocol-summary w-100 text-left m-0">
          <span v-if="!readMore">{{ protocol.summary.slice(0, 200) }}</span>
          <span v-if="readMore">{{ protocol.summary }}</span>
          <a href="#"
             @click.prevent="toggleReadMore" v-if="protocol.summary.length > 200">
            <span v-if="!readMore">Leer más...</span>
            <span v-if="readMore">Mostrar menos</span></a>
        </p>
      </div>
    </div>
    
    <hr>
    
    <div class="row mb-3">
      <div class="col">
        <div class="d-inline-block mr-2">
          <span>Centro:</span>
          <strong>{{ protocol.workplace ? protocol.workplace.key.toUpperCase() : 'No asignado' }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>Código:</span>
          <strong>{{ protocol.id }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>CI:</span>
          <strong>{{ protocol.ci ? protocol.ci : 'No asignado' }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>Folio:</span>
          <strong>{{ protocol.folio_number ? protocol.folio_number : 'No asignado' }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>Tipo de estudio:</span>
          <strong>{{ protocol.study_type ? protocol.study_type.title : 'No asignado' }}</strong>
        </div>
      </div>
    </div>
    
    <div class="row mb-3">
      <div class="col">
        <div class="d-inline-block mr-2">
          <span>Fecha de creación:</span>
          <strong>{{ formatDate(protocol.created_at, 'DD/MM/YYYY') }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>Fecha de envío a comités:</span>
          <strong>{{ protocol.ci_assignment_date ? formatDate(protocol.ci_assignment_date, 'DD/MM/YYYY') : 'No asignada' }}</strong>
        </div>
      </div>
    </div>
    
    <div class="row mb-3" v-if="showDetails">
      <div class="col">
        <div class="d-inline-block mr-2">
          <span>Fecha real de inicio:</span>
          <strong>{{ protocol.real_start_date ? realStartDate : 'No asignada' }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>Fecha real de término:</span>
          <strong>{{ protocol.real_end_date ? realEndDate : 'No asignada' }}</strong>
        </div>
      </div>
    </div>
    
    <div class="row mb-3" v-if="showDetails">
      <div class="col">
        <div class="d-inline-block mr-2">
          <span>Estatus:</span>
          <strong>{{ protocol.status.title }}</strong>
        </div>
      </div>
    </div>
    
    <hr v-if="protocol.primary_line">
    
    <div class="row mb-3" v-if="protocol.primary_line">
      <div class="col d-flex">
        <p class="mb-0 mr-3">
          <span class="font-weight-normal">Línea de investigación principal: </span>
          <span class="font-weight-bold">{{ protocol.primary_line.title }}</span>
        </p>
        
        <p class="mb-0" v-if="protocol.secondary_line">
          <span class="font-weight-normal">Línea de investigación secundaria: </span>
          <span class="font-weight-bold">{{ protocol.secondary_line.title }}</span>
        </p>
      </div>
    </div>
    
    <div class="row mb-3" v-if="protocol.secondary_protocol && showSecondary">
      <div class="col">
        <div>
          <span class="font-weight-bold d-inline-block mr-2">Protocolo madre: </span>
          <a :href="`/protocolo/${protocol.secondary_protocol.mother_protocol.id}/detalles`"
             target="_blank">{{ protocol.secondary_protocol.mother_protocol.title }}</a>
        </div>
        
        <div class="mt-3 w-100">
          <a href="#" @click.prevent="viewSecondaryProtocolJustification">Ver justificación del proyecto</a>
        </div>
      </div>
    </div>
    
    <hr v-if="task && task.classification.key === 'protocolo_solicitado_desarrollo' || showDetails">
    
    <div class="row mb-3" v-if="task && task.classification.key === 'protocolo_solicitado_desarrollo'">
      <div class="col">
        <div class="d-flex mb-3" v-if="task.classification.key === 'protocolo_solicitado_desarrollo'">
          <div class="mr-3">
            <span class="mr-2">Fecha de envío a comités: </span>
            <strong v-text="ciAssigmentDate"></strong>
          </div>
          <div>
            <span class="mr-2">CI: </span>
            <strong v-text="protocol.ci"></strong>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row mb-3" v-if="showAllData">
      <div class="col-12">
        <a href="#" class="btn btn-outline-primary btn-block"
           @click.prevent="showData = !showData" v-text="!showData ? 'Ver más datos' : 'Mostrar menos'"></a>
      </div>
    </div>
    
    <div v-if="showData" class="">
      <div class="row">
        <div class="col-12 mt-3">
          <div class="card card-fluid">
            <div class="card-body">
              <a class="mr-2 btn btn-link btn-lg"
                 :href="protocol.fulltext_file ? `/${protocol.fulltext_file.path}` : '#'"
                 :title="protocol.fulltext_file ? protocol.fulltext_file.name : ''"
                 download
                 target="_blank">
                <i class="fas fa-file-pdf text-red mr-2"></i> Descargar protocol en formato PDF.
              </a>
              
              <a class="mr-2 btn btn-link btn-lg"
                 href="#"
                 @click.prevent="viewLeaderComments">
                <i class="fas fa-external-link-alt mr-2"></i> Observaciones del Líder de Línea.
              </a>
              
              <a class="mr-2 btn btn-link btn-lg"
                 href="#"
                 @click.prevent="viewDirectorComments">
                <i class="fas fa-external-link-alt mr-2"></i> Observaciones del Director de Centro.
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-12">
          <div class="card card-fluid">
            <div class="card-body">
              <a class="mr-2 btn btn-link btn-lg"
                 :href="protocol.fulltext_file ? `/${protocol.fulltext_file.path}` : '#'"
                 download
                 target="_blank">
                <i class="fas fa-file-pdf text-red mr-2"></i> Formato de investigación.
              </a>
              
              <a class="mr-2 btn btn-link btn-lg"
                 v-if="protocol.ethics_questionnaire"
                 :href="`/committee/ethics/questionnaire/${protocol.id}/create`"
                 target="_blank">
                <i class="fas fa-file-pdf text-red mr-2"></i> Cuestionario de ética.
              </a>
              <button class="mr-2 btn btn-link btn-lg"
                      v-else
                      disabled>
                <i class="fas fa-file-pdf text-red mr-2"></i> Cuestionario de ética.
              </button>

              <a class="mr-2 btn btn-link btn-lg"
                 v-if="protocol.biosecurity_questionnaire"
                 :href="`/committee/biosecurity/questionnaire/${protocol.id}/create`"
                 target="_blank">
                <i class="fas fa-file-pdf text-red mr-2"></i> Cuestionario de bioseguridad.
              </a>
              <a class="mr-2 btn btn-link btn-lg"
                 v-else-if="protocol.biosecurity_questionnaire_legacy"
                 :href="`/committee/biosecurity/questionnaire/legacy/${protocol.id}/create`"
                 target="_blank">
                <i class="fas fa-file-pdf text-red mr-2"></i> Cuestionario de bioseguridad.
              </a>
              <button class="mr-2 btn btn-link btn-lg"
                      v-else
                      disabled>
                <i class="fas fa-file-pdf text-red mr-2"></i> Cuestionario de bioseguridad.
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-6">
          <div class="card card-fluid m-0">
            <div class="card-header">
              <div class="font-weight-bold">Financiadora(s):</div>
            </div>
            <div class="card-body">
              <funders-list :protocol="protocol"
                            :funders="protocol.funders"
                            v-if="protocol.funders.length"
                            class="list-group-flush"></funders-list>
              
              <div v-else>
                <p class="alert alert-warning">No se asignaron financiadoras al protocolo</p>
                <p class="font-weight-bold">Justificación:</p>
                <textarea rows="5" cols="5" readonly disabled
                          class="form-control">{{protocol.financing_information.other_means}}</textarea>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-6">
          <div class="card card-fluid">
            <div class="card-header">
              <div class="font-weight-bold">Investigador(es) asignado(s):</div>
            </div>
            <div class="card-body">
              <researchers-list :researchers="protocolResearchers"
                                :protocol="protocol"
                                :show-header="false"
                                :show-actions="false"
                                :show-status="false"
                                ref="researchers-list"
                                v-if="protocolResearchers.length"
                                class="list-group-flush"></researchers-list>
              
              <div v-else>
                <p class="alert alert-warning">No se asignaron coinvestigadores al protocolo</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <portal to="protocol-modals">
      <ok-cancel-dialog id="protocol-evaluation-modal"
                        ref="protocol-evaluation-modal"
                        title="Evaluación de protocolo"
                        :content="evaluation"
                        :show-ok-button="false"
                        keyboard="true"
                        backdrop="default">
      </ok-cancel-dialog>
    </portal>
    
    <portal to="dictums-modals" v-if="protocol.secondary_protocol">
      <ok-cancel-dialog id="secondary-protocol-modal"
                        ref="secondary-protocol-modal"
                        title="Justificación de protocolo secundario"
                        :content="protocol.secondary_protocol.justification"
                        :show-ok-button="false"
                        keyboard="true"
                        large
                        scrollable
                        backdrop="default">
      </ok-cancel-dialog>
    </portal>
  </header>
</template>

<script>
  import moment from 'moment'
  import FundersList from './FundersList'
  import ResearchersList from './ResearchersList'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'ProtocolHeader',
    components: {
      FundersList,
      ResearchersList,
      OkCancelDialog,
    },
    props: {
      protocol: Object,
      task: {
        type: Object,
        required: false,
        default: null,
      },
      showAllData: {
        type: Boolean,
        default: false,
      },
      showDetails: {
        type: Boolean,
        default: false,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      showSecondary: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        readMore: false,
        showData: false,
        evaluation: '',
      }
    },
    methods: {
      toggleReadMore () {
        this.readMore = !this.readMore
      },
      
      viewLeaderComments () {
        this.evaluation = this.protocol.leader_evaluation
        
        $('#protocol-evaluation-modal').modal('show')
      },
      
      viewDirectorComments () {
        this.evaluation = this.protocol.director_evaluation
        
        $('#protocol-evaluation-modal').modal('show')
      },
      formatDate (date, format) {
        return moment(date).format(format)
      },
      
      viewSecondaryProtocolJustification () {
        $('#secondary-protocol-modal').modal('show')
      },
    },
    computed: {
      ...mapGetters({
        funders: 'protocols/funders',
        researchers: 'protocols/researchers',
      }),
      
      ciAssigmentDate () {
        if (this.protocol) {
          return moment(this.protocol.ci_assignment_date).format('DD/MM/YYYY')
        }
        
        return ''
      },
      
      protocolResearchers () {
        if (this.researchers.length) {
          return this.researchers.sort((a, b) => {
            if (a.full_name > b.full_name) return 1
            if (a.full_name < b.full_name) return -1
            
            return 0
          })
        }
        
        return this.protocol.researchers.sort((a, b) => {
          if (a.full_name > b.full_name) return 1
          if (a.full_name < b.full_name) return -1
          
          return 0
        })
      },
  
      realStartDate() {
        if (this.protocol && this.protocol.real_start_date) {
          return moment(this.protocol.real_start_date).format('DD/MM/YYYY')
        }
    
        return ''
      },
  
      realEndDate() {
        if (this.protocol && this.protocol.real_end_date) {
          return moment(this.protocol.real_end_date).format('DD/MM/YYYY')
        }
    
        return ''
      },
    },
  }
</script>
